<template>
  <div class="assess-rank">
    <ComBox>
      <template #title>
        <TitleBar title="火点考核排名" :icon="icon">
          <template #right>
            <TabBar :list="tabList" v-model="currentTab" @change="changeTab"/>
          </template>
        </TitleBar>
      </template>
      <div class="table-wrapper">
        <ComTable v-if="refresh" :columns="columns" :data="tableData">
          <template #index="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
        </ComTable>
      </div>
    </ComBox>
  </div>
</template>

<script>
  import TitleBar from "../../common/TitleBar.vue";
  import ComBox from "../../common/ComBox.vue";
  import TabBar from "../../common/TabBar.vue";
  import ComTable from "../../common/ComTable.vue";
  import icon from "@/assets/dataScreen/icon-rank.png";
  import { getFireWarningRanking } from "../../../../../api/dataScreen";
  import { changeDateTab } from "../../../../../utils/time";

  export default {
    name: "AssessRank",
    components: { TitleBar, ComBox, TabBar, ComTable },
    data() {
      return {
        icon,
        currentTab: "0",
        refresh: false,
        searchForm: {
          startTime: '',
          endTime: ''
        },
        tabList: [
          { label: "今日累计", value: "0" },
          { label: "昨日", value: "1" },
          { label: "本月", value: "2" },
          { label: "本年", value: "3" },
        ],
        columns: [
          {
            prop: "index",
            label: "排名",
            width: "10%",
            slot: "index",
          },
          {
            prop: "townName",
            label: "乡镇",
            width: "20%",
          },
          {
            prop: "totalCount",
            label: "火点警报",
            width: "15%",
            sort: true
          },
          {
            prop: "processedCount",
            label: "已处理",
            width: "15%",
            sort: true
          },
          {
            prop: "unprocessedCount",
            label: "未处理",
            width: "15%",
            sort: true
          },
        ],
        tableData: [],
      };
    },
    created() {},
    mounted() {
      this.changeTab('0')
    },
    methods: {
      changeTab (val) {
        this.searchForm.startTime = changeDateTab(val)[0]
        this.searchForm.endTime = changeDateTab(val)[1]
        this.getList()
      },
      getList () {
        this.refresh = false
        getFireWarningRanking(this.searchForm).then(res => {
          this.tableData = res.data
          this.refresh = true
        })
      }
    },
  };
</script>

<style scoped lang="less">
  .assess-rank {
    width: 100%;
    height: auto;
    flex: 5;

    .table-wrapper {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding: 15px 0;
    }
  }
</style>
